const en = {
	groupDelimiter:",",
	groupSize:3,
	decimalDelimiter:".",
	decimalSize:2,

	dateFormat:"%m/%d/%Y",
	timeFormat:"%h:%i %A",
	longDateFormat:"%d %F %Y",
	fullDateFormat:"%m/%d/%Y %h:%i %A",
	am:["am","AM"],
	pm:["pm","PM"],

	price:"${obj}",
	priceSettings:{
		groupDelimiter:",",
		groupSize:3,
		decimalDelimiter:".",
		decimalSize:2
	},
	fileSize: ["b","Kb","Mb","Gb","Tb","Pb","Eb"],
	
	calendar: {
		monthFull:["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
		monthShort:["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
		dayFull:["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
		dayShort:["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		hours: "Hours",
		minutes: "Minutes",
		done:"Done",
		clear: "Clear",
		today: "Today"
	},

	dataExport:{
		page:"Page",
		of:"of"
	},
	PDFviewer:{
		of:"of",
		automaticZoom:"Automatic Zoom",
		actualSize:"Actual Size",
		pageFit:"Page Fit",
		pageWidth:"Page Width",
		pageHeight:"Page Height",
		enterPassword:"Enter password",
		passwordError:"Wrong password"
	},
	aria:{
		calendar:"Calendar",
		increaseValue:"Increase value",
		decreaseValue:"Decrease value",
		navMonth:["Previous month", "Next month"],
		navYear:["Previous year", "Next year"],
		navDecade:["Previous decade", "Next decade"],
		dateFormat:"%d %F %Y",
		monthFormat:"%F %Y",
		yearFormat:"%Y",
		hourFormat:"Hours: %h %A",
		minuteFormat:"Minutes: %i",
		removeItem:"Remove item",
		pages:["First page", "Previous page", "Next page", "Last page"],
		page:"Page",
		headermenu:"Header menu",
		openGroup:"Open column group",
		closeGroup:"Close column group",
		closeTab:"Close tab",
		showTabs:"Show more tabs",
		resetTreeMap:"Reset tree map",
		navTreeMap:"Level up",
		nextTab:"Next tab",
		prevTab:"Previous tab",
		multitextSection:"Add section",
		multitextextraSection:"Remove section",
		showChart:"Show chart",
		hideChart:"Hide chart",
		resizeChart:"Resize chart"
	},
	richtext:{
		underline: "Underline",
		bold: "Bold",
		italic: "Italic"
	},
	combo:{
		select:"Select",
		selectAll:"Select all",
		unselectAll:"Unselect all"
	},
	message:{
		ok:"OK",
		cancel:"Cancel"
	},
	comments:{
		send: "Send",
		confirmMessage: "The comment will be removed. Are you sure?",
		edit: "Edit",
		remove: "Remove",
		placeholder: "Type here..",
		moreComments:"More comments"
	},
	filter:{
		less: "less",
		lessOrEqual: "less or equal",
		greater: "greater",
		greaterOrEqual: "greater or equal",
		contains: "contains",
		notContains: "not contains",
		equal: "equal",
		notEqual: "not equal",
		beginsWith: "begins with",
		notBeginsWith: "not begins with",
		endsWith: "ends with",
		notEndsWith: "not ends with",
		between: "between",
		notBetween: "not between"
	}
};

export default en;